import React from 'react'

import { SKELETON_ITEMS_COUNT } from 'shared/consts/index'

import './SkeletonLoader.scss'

const SkeletonLoader = () => (
  <>
    {[...Array(SKELETON_ITEMS_COUNT).keys()].map((index) => (
      <div key={index} className="project-skeleton">
        <div className="project-skeleton__row">
          <div className="project-skeleton__avatar" />
          <div className="project-skeleton__body" />
        </div>
        <div className="project-skeleton_row">
          <div className="project-skeleton__body" />
        </div>
      </div>
    ))}
  </>
)

export default SkeletonLoader
